import { request } from '@/common/utils/request'
// 商圈新增接口开始
// new门店tab权限控制
export function fetchTabAuth(params) {
  return request.get({
    url: 'feidian.bdapp.bizopp.getTabAuth',
    params,
  })
}
// old获取通用门店列表数据
export function fetchStoreList(params) {
  return request.post({
    url: 'feidian.bdapp.bizopp.getList',
    params,
  })
}
// new获取商圈门店列表的数据
export function fetchAreaStoreList(params) {
  return request.post({
    url: 'feidian.bdapp.area.getList',
    params,
  })
}
//  new根据经纬度获取城市
export function fetchCityByPoi(params) {
  return request.get({
    url: 'feidian.bdapp.common.getCityByPoi',
    params,
  })
}
// new获取通用三个tab的商圈数据
export function fetchBizoppAreaTree(params) {
  return request.get({
    url: 'feidian.bdapp.bizopp.getAreaTree',
    params,
  })
}
// new获取tab商圈数据
export function fetchAreaTree(params) {
  return request.get({
    url: 'feidian.area.bdapp.getAreaTree',
    params,
  })
}
// 商圈新增接口结束

// 获取搜索页商机列表数据rename
export function fetchBizoppResultList(params) {
  return request.post({
    url: 'feidian.bdapp.bizopp.getSearchResultList',
    params,
  })
}
// 获取商机详情rename
export function fetchBizoppInfo(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getBizoppInfo',
    params,
  })
}
// 根据国家获取品类列表rename
export function fetchCategoryListByCountry(params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getCategoryByCountry',
    params,
  })
}

// 获取业务策略数据rename
export function getStrategyTagByBusiness(params) {
  return request.get({
    url: 'feidian.bdapp.bizopp.getStrategyTag',
    params,
  })
}

/**
 * 获取管理视图销售姓名rename
 * @param {*} params
 * @returns
 */
export async function getBDNameRelationTree(params = {}) {
  params.special = 1
  return request
    .get({
      url: 'feidian.common.getBdRelationTree',
      params,
    })
    .then(res => {
      return res.data
    })
}

// 获取门店页面的标签筛选项数据rename
export function getBizoppTagsTree(params) {
  return request
    .get({
      url: 'feidian.bdapp.bizopp.getTagsTree',
      params: {
        ...params,
      },
    })
    .then(({ errno, data, errmsg }) => {
      if (+errno !== 0) {
        throw new Error(errmsg)
      }
      return data
    })
    .catch(e => {
      console.warn(e)
      return []
    })
}

// 获取BD名下各标签的店铺列表
export function getNewRsListByFlag(params) {
  return request.get({
    url: 'feidian.bdapp.bizopp.getNewRsListByFlag',
    params,
  })
}
